import React from 'react';
import AdminFormattedMessages from '../../messages/admin/AdminFormattedMessages';
import AdminDebugEmail from '../../components/admin/debug/Email';
import AdminDebugPDF from '../../components/admin/debug/PDF';
import Layout from '../../components/layouts/Layout';
import { Divider, Stack, Typography } from '@mui/material';
import { AdminRoutes } from '../../routes/AdminRoutes';

const AdminDebug = (props) => {
  const { accessLevel, accessType } = props;

  return (
    <Layout
      title={AdminFormattedMessages.debug}
      routes={AdminRoutes}
      accessLevel={accessLevel}
      accessType={accessType}
    >
      <Stack gap={2}>
        <Typography>Tools to debug different services.</Typography>

        <Divider />

        <AdminDebugEmail errorHandler={props.errorHandler} />

        <Divider />

        <AdminDebugPDF errorHandler={props.errorHandler} />
      </Stack>
    </Layout>
  );
};

export default AdminDebug;
